import { createSliceContext } from "./CreateSliceContext";

interface TermsOfServiceModalSliceData {
  show?: boolean;
  onHide?: () => void;
}

const defaultTermsOfServiceModalValues: TermsOfServiceModalSliceData = {
  show: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHide: () => {},
};

export const {
  Provider: TermsOfServiceModalSliceProvider,
  useContext: useTermsOfServiceModalSliceContext,
} = createSliceContext<TermsOfServiceModalSliceData>(
  "TermsOfServiceModal",
  defaultTermsOfServiceModalValues
);
